import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const focus = [
  "AI Strategy & Solutions",
  "Smart Glass Development",
  "IoT & Asset Tracking",
  "Hardware + Software Integration",
  "AI Training",
  "Rapid Prototyping",
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050505] relative overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <Link to="/" data-testid="footer-brand" className="flex items-baseline gap-2">
              <span className="font-unbounded font-semibold tracking-tight text-2xl text-white">IQ·AI</span>
              <span className="font-mono text-[10px] tracking-[0.3em] text-neutral-500">SOLUTIONS</span>
            </Link>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-neutral-400">
              Technology consulting for businesses that want emerging technology turned into practical, working solutions — from the device in the field to the intelligence in the cloud.
            </p>
            <a
              href="mailto:iq.ai.solutions@gmail.com"
              data-testid="footer-email-link"
              className="mt-6 inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] text-cyan hover:text-cyan-hover transition-colors duration-300"
            >
              IQ.AI.SOLUTIONS@GMAIL.COM <ArrowUpRight size={13} />
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] tracking-[0.3em] text-neutral-500 mb-6">// NAVIGATE</p>
            <ul className="space-y-3">
              {[
                { to: "/", label: "Home" },
                { to: "/services", label: "Services" },
                { to: "/experience", label: "Experience" },
                { to: "/about", label: "About" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-sm text-neutral-400 hover:text-cyan transition-colors duration-300"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[10px] tracking-[0.3em] text-neutral-500 mb-6">// FOCUS AREAS</p>
            <ul className="space-y-3">
              {focus.map((f) => (
                <li key={f} className="text-sm text-neutral-400 flex items-center gap-3">
                  <span className="w-1 h-1 bg-cyan/70" />
                  {f}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-mono text-[10px] tracking-[0.25em] text-neutral-600">
            © {new Date().getFullYear()} IQAISOLUTIONS.COM — ALL SYSTEMS OPERATIONAL
          </p>
          <p className="font-mono text-[10px] tracking-[0.25em] text-neutral-600">
            HARDWARE <span className="text-cyan">×</span> SOFTWARE <span className="text-cyan">×</span> AI
          </p>
        </div>
      </div>
    </footer>
  );
}
